<div class="pop-up">
    <h1 mat-dialog-title style="text-align: center; color:blue;">NUEVO REPORTROW</h1>
    <div>
        <mat-form-field style="width: 80%;">
            <mat-label>Titulo</mat-label>
            <input matInput type="text " [(ngModel)]="rRow.titulo">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>Orden</mat-label>
            <input matInput type="text " [(ngModel)]="rRow.orden">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>unidadT</mat-label>
            <input matInput type="text " [(ngModel)]="rRow.unidadT">
        </mat-form-field>
        <br>
        <mat-form-field style="width: 80%;">
            <mat-label>unidadK</mat-label>
            <input matInput type="text " [(ngModel)]="rRow.unidadK">
        </mat-form-field>
        <br>
    </div>
    <div>
        <button class="validar" mat-button mat-button [mat-dialog-close]="null">CARCELAR</button>
        <button class="validar" mat-button mat-button [mat-dialog-close]="rRow" cdkFocusInitial>OK</button>
    </div>
</div>